export default {"src":"/_next/static/media/stx.ab2d61aa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};